import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "@common/textInput";

import { ProjectPortfolioTag } from "@common/projectPortfolioTag";
import { Props } from "./types";
import { ColorPickerInput } from "./colorPickerInput";
import { ProjectSelection } from "./projectSelection";
import styles from "./styles.scss";

function Form({ projects, formData, error, editForm }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("projectPortfolioEdition.nameTitle")}
        </h3>
        <div className={styles.row}>
          <div className={styles.textInput}>
            <TextInput
              placeholder={t("projectPortfolioEdition.namePlaceholder")}
              value={formData.name}
              input={(name) => editForm({ ...formData, name })}
              isInvalid={
                error.portfolioNameIsNotUnique || error.portfolioNameIsEmpty
              }
            />
          </div>
          <ColorPickerInput
            color={formData.color}
            edit={(color) => editForm({ ...formData, color })}
          />
          {!!formData.name && !!formData.color && (
            <div className={styles.tag}>
              <ProjectPortfolioTag
                name={formData.name}
                color={formData.color}
              />
            </div>
          )}
        </div>
      </div>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("projectPortfolioEdition.projectSelectionTitle")}
        </h3>
        <ProjectSelection
          placeholder={t("projectPortfolioEdition.projectSelectionPlaceholder")}
          projects={projects}
          selectedProjects={formData.projects}
          selectProjects={(projects) => editForm({ ...formData, projects })}
        />
      </div>
      <div className={styles.group}>
        <h3 className={styles.label}>
          {t("projectPortfolioEdition.descriptionTitle")}
        </h3>
        <div className={styles.description}>
          <TextInput
            placeholder={t("projectPortfolioEdition.descriptionPlaceholder")}
            value={formData.description}
            input={(description) => editForm({ ...formData, description })}
            isMultiline
          />
        </div>
      </div>
    </div>
  );
}

export { Form };
